function moveSelectionToStart(el) {
    el.setSelectionRange(0, 0);
}
function moveSelectionToEnd(el) {
    const n = el.value.length;
    el.setSelectionRange(n, n);
}
function containsSelectedText(el) {
    const selection = window.getSelection();
    if (selection && !selection.isCollapsed && selection.toString().length > 0) {
        if (el.contains(selection.anchorNode) || el.contains(selection.focusNode)) {
            return true;
        }
    }
    return false;
}
function isTextInputWithSelection(el) {
    if (el.nodeName === 'LABEL') {
        // when an input nested inside a label is clicked, the target will be the label
        el = el.control ?? el;
    }
    return canHaveSelection(el) ? hasSelectedText(el) : false;
}
function hasSelectedText(el) {
    return el.selectionStart !== el.selectionEnd;
}
function canHaveSelection(el) {
    if (el.nodeName === 'TEXTAREA')
        return true;
    if (el.nodeName === 'INPUT') {
        return /^(text|search|url|tel|password)$/i.test(el.type);
    }
    return false;
}

export { canHaveSelection, containsSelectedText, hasSelectedText, isTextInputWithSelection, moveSelectionToEnd, moveSelectionToStart };
//# sourceMappingURL=selection.js.map
